const Header = (({ jQuery: $ }) => {
    class Header {
        constructor(node) {
            this.$node = $(node);
            this.headerHeight = this.$node[0].clientHeight;
            this.$siteContent = $('[data-js="site-content"]');
            this.$heroFrontpage = $('[data-js="hero-frontpage"]');
            this.$hero = this.$heroFrontpage.length
                ? this.$heroFrontpage
                : $('#header-image');
        }

        adjustContentToFitNav() {
            this.$siteContent.css('top', this.headerHeight);
        }

        toggleNavShadow() {
            let heroHeight = this.$hero[0].clientHeight;
            let shadowApplied = $(this.$node).is('.content-shadow');

            if ($(window).scrollTop() > heroHeight) {
                if (shadowApplied) return;
                this.$node.addClass('content-shadow');
            } else {
                this.$node.removeClass('content-shadow');
            }
        }

        setFrontpageHeroHeight() {
            let winHeight = window.innerHeight;

            this.$hero.css(
                'height',
                winHeight - (this.headerHeight + this.headerHeight / 2)
            );
        }

        setMobileHero() {
            if ($(window).innerWidth() <= 480) {
                let mobileHeroUrl =
                    'url(' + window.helpers.mobile_hero_url + ')';
                this.$hero.css('background-image', mobileHeroUrl);
            } else {
                let heroUrl = 'url(' + window.helpers.hero_url + ')';
                this.$hero.css('background-image', heroUrl);
            }
        }

        frontpageAdjustments() {
            if (!this.$heroFrontpage.length) {
                return;
            }

            this.setFrontpageHeroHeight();
            this.setMobileHero();
        }

        onWindowResize() {
            this.adjustContentToFitNav();
            this.frontpageAdjustments();
        }

        setEventBindings() {
            $(window).on('resize', this.onWindowResize.bind(this));
            $(window).on('scroll', this.toggleNavShadow.bind(this));
        }

        shouldInit() {
            if (this.$hero.length) return true;
        }

        init() {
            if (!this.shouldInit()) {
                return;
            }

            this.frontpageAdjustments();
            this.adjustContentToFitNav();
            this.setEventBindings();
        }
    }

    return {
        init({ selector }) {
            return new Header(selector).init();
        },
    };
})(window);

export default Object.create(Header);
